<template>
  <div
    ref="TmyChart"
    id="myTrendChart"
    :style="{ width: '100%', height: 'calc(100% - 1px)' }"
  ></div>
</template>

<script>
import halloween from "../../../static/halloween";
import maxInputMixin from "../../mixins/maxInputMixin";
import toolboxMixin from "../../mixins/toolboxMixin";
import commonMixin from "../../mixins/commonMixin";
import graphicMixin from '@/mixins/graphicMixin'
import brushMixin from '@/mixins/brushMixin'
import {changeGraphData, revertGraphData} from '../../components/ComUtils/ChangeGraphData'
import toolboxTrendGraphMixin from "../../mixins/toolboxTrendGraphMixin";
import keyPressSlotMixin from '@/mixins/keyPressSlotMixin'
import keepAliveMixin from "@/mixins/keepAliveMixin";
import reDataZoomMixin from "../../mixins/reDataZoomMixin";
import {timestampToTimeFormat, timeStringToTimestamp} from "./TimeFormat";
import {numberUtilsMixin} from "../../mixins/numberUtilsMixin";
import offsetsMixin from "../../mixins/offsetsMixin";
import EventComparisonMixin from "../../mixins/EventComparisonMixin";
var elementResizeDetectorMaker = require("element-resize-detector");
import wavePointMixin from "../../mixins/wavePointMixin";

export default {
  name: "TrendGraph",
  props: ['tongDao', 'response', 'pointType', "nowtimeStatic", "AlarmValueY",'markValue','requestData'],
  mixins: [maxInputMixin, commonMixin, toolboxMixin, toolboxTrendGraphMixin, offsetsMixin, graphicMixin, brushMixin, keyPressSlotMixin, keepAliveMixin,reDataZoomMixin, numberUtilsMixin,EventComparisonMixin,wavePointMixin],
  data() {
    return {
      tongDaoType: '0',
      Title: '',
      mainCursor: '',//主游标值
      auxiliaryCursor: '',//辅游标值
      offset: '',
      status: "", //实时或者历史
      typename: '趋势图',
      allseries: [],
      aline: [],
      refineFlag: false,
      mychart: null,
      arrx: [],
      arry: [],
      ymin: "",
      ymax: "",
      iscan: false,
      mycolor: "grey",
      nowStatic: true,
      AlarmValueData: [],
      positionMap: ['insideEndTop', 'insideEndBottom', 'insideEndTop', 'insideEndBottom'],
      maxXInputMixin: { // 关闭x轴修改最大值的input框
        show: false
      },
      isFull: false,
      isReal: "real",
      nowOption: null,
      legendData: [],//保存图例名称
      graphType: '趋势图',
      tooltipIndex: '',
      tooltipSeriesIndex: '',
      isMouseInChart: false,
      FullScreenName: this.translateText("textMap.",'全屏'),
      icon: "M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M7.48,6.51l2.81-2.67\n" +
        "\t M10.79,6.09V3.62c0-0.22-0.18-0.39-0.39-0.39h-2.6 M6.68,7.36L3.84,10 M3.37,7.74l-0.03,2.47c0,0.22,0.17,0.39,0.39,0.4l2.6,0.03",
      //icon: "M19.2,179.9,8,30.5A17.93,17.93,0,0,1,24.6,11.3a10.45,10.45,0,0,1,2.5,0L176.5,21.4m-163-3.5L216.4,218.3M577,179.1,588.2,29.7a18.08,18.08,0,0,0-16.6-19.3,10.45,10.45,0,0,0-2.5,0l-149.4,10m162-4.4L379.8,217.3M19.2,419.7,8,569.1a18.08,18.08,0,0,0,16.6,19.3,10.45,10.45,0,0,0,2.5,0l149.4-10.1m-163,3.5L216.4,381.4M419.6,579.2l149.4,10a18.09,18.09,0,0,0,19.2-16.8,10.45,10.45,0,0,0,0-2.5L577,420.6m4.8,163.1-202-201.4",
    };
  },
  computed: {
    myicon() {
      return this.isFull;
    },
    topiccolor() {
      return this.$store.state.topiccolor;
    },
  },
  watch: {
    tongDao(value){
      this.tongDaoType = value
      this.aline = []
    },
    nowtimeStatic(data) {
      if(!this.activatedFlag) return ;
      this.nowStatic = data;
    },
    AlarmValueY(data) {
      if(!this.activatedFlag) return ;
      this.AlarmValueData = data;
      // console.log("this.AlarmValueData",this.AlarmValueData)
    },
    myicon(val) {
      if (val == true) {
        this.FullScreenName = this.translateText("textMap.",'退出全屏');
        this.icon = 'M13.5,7.1c0,3.7-2.9,6.5-6.5,6.5s-6.5-2.9-6.5-6.5c0-3.7,2.9-6.5,6.5-6.5S13.5,3.4,13.5,7.1z M3.3,10.7l2.8-2.7\n' +
          '\t M6.6,10.3V7.8c0-0.2-0.2-0.4-0.4-0.4H3.6 M7.9,6l2.9-2.6 M7.5,3.8l0,2.5c0,0.2,0.2,0.4,0.4,0.4l2.6,0';
        // this.icon =
        //   'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M3.29,10.73L6.1,8.06\n' +
        //   '\t M6.59,10.31V7.84c0-0.22-0.18-0.39-0.39-0.39h-2.6 M7.95,6.03L10.8,3.4 M7.49,3.78L7.46,6.25c0,0.22,0.17,0.39,0.39,0.4l2.6,0.03';
        //"M393,48.24,381.73,197.59a18,18,0,0,0,16.61,19.29,17.8,17.8,0,0,0,2.53,0l149.44-10m-162.08,4.42L590.16,10M207,549.69l11.17-149.37a18,18,0,0,0-16.63-19.27,17.52,17.52,0,0,0-2.51,0L49.59,391.16m163.12-3.52L9.84,588";
      } else {
        this.FullScreenName = this.translateText("textMap.",'全屏');
        this.icon =
          'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M7.48,6.51l2.81-2.67\n' +
          '\t M10.79,6.09V3.62c0-0.22-0.18-0.39-0.39-0.39h-2.6 M6.68,7.36L3.84,10 M3.37,7.74l-0.03,2.47c0,0.22,0.17,0.39,0.39,0.4l2.6,0.03';
        //"M19.2,179.9,8,30.5A17.93,17.93,0,0,1,24.6,11.3a10.45,10.45,0,0,1,2.5,0L176.5,21.4m-163-3.5L216.4,218.3M577,179.1,588.2,29.7a18.08,18.08,0,0,0-16.6-19.3,10.45,10.45,0,0,0-2.5,0l-149.4,10m162-4.4L379.8,217.3M19.2,419.7,8,569.1a18.08,18.08,0,0,0,16.6,19.3,10.45,10.45,0,0,0,2.5,0l149.4-10.1m-163,3.5L216.4,381.4M419.6,579.2l149.4,10a18.09,18.09,0,0,0,19.2-16.8,10.45,10.45,0,0,0,0-2.5L577,420.6m4.8,163.1-202-201.4";
      }

      var option = {
        toolbox: {
          feature: {
            myCancel: {
              icon: this.icon,
              title: this.FullScreenName,
            },
          },
        },
      };
      this.mychart.setOption(option);
    },
    topiccolor(val) {
      this.$refs.TmyChart.style.setProperty('--textcolor', this.$store.state.textcolor);
      this.$refs.TmyChart.style.setProperty('--bgcolor', this.$store.state.bgcolor);
      this.$refs.TmyChart.style.setProperty('--tablecolor', this.$store.state.tablecolor);
      this.$refs.TmyChart.style.setProperty('--buttoncolor', this.$store.state.buttoncolor);
      this.$refs.TmyChart.style.setProperty('--buttontextcolor', this.$store.state.buttontextcolor);
      this.$refs.TmyChart.style.setProperty('--conbgcolor', this.$store.state.conbgcolor);
      this.$refs.TmyChart.style.setProperty('--defaultButtonColor', this.$store.state.defaultButtonColor);
    }
  },
  mounted() {
    this.$refs.TmyChart.style.setProperty('--textcolor', this.$store.state.textcolor);
    this.$refs.TmyChart.style.setProperty('--bgcolor', this.$store.state.bgcolor);
    this.$refs.TmyChart.style.setProperty('--tablecolor', this.$store.state.tablecolor);
    this.$refs.TmyChart.style.setProperty('--buttoncolor', this.$store.state.buttoncolor);
    this.$refs.TmyChart.style.setProperty('--buttontextcolor', this.$store.state.buttontextcolor);
    this.$refs.TmyChart.style.setProperty('--conbgcolor', this.$store.state.conbgcolor);
    this.$refs.TmyChart.style.setProperty('--defaultButtonColor', this.$store.state.defaultButtonColor);
    this.$nextTick(() => {
      this.drawchart();
    });
    const resizeObeserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.$nextTick( () => {
          if(entry.contentRect.height != 0 && entry.contentRect.width != 0){ //被隐藏时，不再resize(),避免显示时出现堆叠问题
            this.mychart.resize();
            this.resizeMaxInput();
            this.updateMarkPoint()
            this.mychart.setOption({
              title: [
                {
                  id: 'Auxiliary-Cursor',
                  left: this.mychart.getWidth() * parseFloat(this.$store.state.grid.left) / 100 + 300,
                  top: "32px",
                  textStyle:{
                    fontSize: 10,
                    color: this.$store.state.primarySecondaryColor[1],
                  }
                }
              ],
            })
          }
        })
      }
    });
    try {
      resizeObeserver.observe(this.$refs.TmyChart)
    } catch (error) {
      console.log(error)
    }
  },
  methods: {





    /**
     * 图表鼠标单击事件处理
     * 使用方法，任意位置注册即可
     * this.mychart.getZr().off("click");
     * this.mychart.getZr().on("click", this.chartClick);
     * @param params
     */
    // chartClick(params) {
    //   const pointInPixel = [params.offsetX, params.offsetY];
    //   if (this.mychart.containPixel("grid", pointInPixel)) {
    //     let pointInGrid = this.mychart.convertFromPixel(
    //       { seriesIndex: 0 },
    //       pointInPixel
    //     );
    //     //X轴序号
    //     var xIndex = pointInGrid[0];
    //     //Y轴序号
    //     var yIndex = pointInGrid[1];
    //     //获取当前图表的option
    //     var op = this.mychart.getOption();
    //     //获得图表中我们想要的数据封装为param {name: '2022-03-05 07:51:38.785', seriesName: '2级A壳体振动V'}
    //     var param = {};
    //     param.name = op.xAxis[0].data[xIndex];
    //
    //     // 获取离鼠标最近的 series 的线的名字，以便提供给其它组件
    //     var min = Number.MAX_VALUE;
    //     var seriesNameIndex = 0;
    //     for (var i = 0; i < op.series.length; i++) {
    //       if (Math.abs(op.series[i].data[xIndex] - yIndex) < min) {
    //         min = Math.abs(op.series[i].data[xIndex] - yIndex);
    //         seriesNameIndex = i;
    //       }
    //     }
    //
    //     param.seriesName = op.series[seriesNameIndex].name;
    //
    //     // 画两条线
    //     this.drawLineAndProLine(param.name)
    //     // 告诉父组件刷新其它页面
    //     this.$emit("chartinfo", param);
    //   }
    // },

    /* 用于合并图标的option和报警线的option*/
    formatTimestamp(ts) {
      return timestampToTimeFormat(ts);
    },

    setIsFull(data) {
      this.isFull = data;
    },
    drawchart() {
      let that = this;
      if (that.mychart) {
        that.mychart.clear();

        that.arrx = [];
        that.arry = [];
      } else {
        that.echarts.registerTheme("halloween", halloween);
        that.mychart = that.echarts.init(that.$refs.TmyChart, "halloween");
      }

      var defaultoption = {
        backgroundColor: this.$store.state.leftconbgcolor,
        grid: [
          {
            left: this.$store.state.grid.left,
            right: this.$store.state.grid.right,
            top: this.$store.state.grid.top,
            bottom: this.$store.state.grid.trendBottom,
          },
        ],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          icon: 'rect',
          y: "bottom",
          x: "left",
          // 图例样式修改
          // itemWidth: 9,
          // itemHeight: 9,
          textStyle: {
            fontSize: 10,
            // color: this.$store.state.textcolor,
            color: this.$store.state.topiccolor == 'blue' ? this.$store.state.blueAxisLableColor : this.$store.state.textcolor,
          },
        },
        xAxis: {
          axisLine: {
            onZero: false,
          },
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            color: this.$store.state.selectbordercolor,
            // color: this.$store.state.textcolor,
            overflow: 'break', // 文本超出宽后进行换行
            width: 70,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", //'dotted'虚线 'solid'实线，
              color: this.$store.state.linecolor,
            },
          },
          type: "category",
        },
        yAxis: {
          boundaryGap: [0.2, 0.2],
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            color: this.$store.state.selectbordercolor,
            // color: this.$store.state.textcolor,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", //'dotted'虚线 'solid'实线，
              color: this.$store.state.linecolor,
            },
          },
          type: "value",
          splitNumber: 3,
        },
      };
      // console.log('default start')
      that.mychart.setOption(defaultoption);
      // console.log('default ok')
    },
    clearall() {
      let that = this;
      if (that.mychart) {
        that.mychart.clear();

      }else{
        return
      }
      var defaultoption = {
        backgroundColor: this.$store.state.leftconbgcolor,
        grid: {
          left: this.$store.state.grid.left,
          right: this.$store.state.grid.right,
          top: this.$store.state.grid.top,
          bottom: this.$store.state.grid.trendBottom,
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          icon: 'rect',
          y: "bottom",
          x: "left",
          // 图例样式修改
          // itemWidth: 9,
          // itemHeight: 9,
          textStyle: {
            fontSize: 10,
            // color: this.$store.state.textcolor,
            color: this.$store.state.topiccolor == 'blue' ? this.$store.state.blueAxisLableColor : this.$store.state.textcolor,
          },
        },
        xAxis: {
          axisLine: {
            onZero: false,
          },
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            color: this.$store.state.textcolor,
            overflow: 'break', // 文本超出宽后进行换行
            width: 70,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", //'dotted'虚线 'solid'实线，
              color: this.$store.state.linecolor,
            },
          },
          type: "category",
        },
        yAxis: {
          boundaryGap: [0.2, 0.2],
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            color: this.$store.state.textcolor,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", //'dotted'虚线 'solid'实线，
              color: this.$store.state.linecolor,
            },
          },
          type: "value",
          splitNumber: 3,
          min: 0,
          max: 3,
        },
      };
      this.clear()
      that.mychart.setOption(defaultoption);
    },

    async setchartdata(flagX, flagY, dataX, dataY, title, type,mpoint = []) {
      this.saveGraphData(flagX, flagY, dataX, dataY, title, type, true);
      let that = this;
      //flagX: 横轴名称单位, string
      //flagY: 纵轴名称单位， string
      //dataX : 横轴数据 ,  [] 每一项是数据
      //dataY: 纵轴数据 ,  [] 每一项是一个json
      //                       json 内容格式 {
      //                                 name:曲线名称,  string
      //                                 data:曲线数据， []
      //                                 color:曲线颜色， string eg: #*****
      //                             }
      // console.log(flagX, flagY, dataX, dataY, title, type)
      // console.log(this.modelFlag, type);

      let routeFlag = this.$route.path.indexOf('StartStopGraph') == -1;
      if (type != 'real') {
        if (this.modelFlag && routeFlag && this.$route.path.indexOf('ReciprocatAlarmQuery') == -1 && this.$route.path.indexOf('AlarmQuery') == -1) {
          let changeData = changeGraphData(dataX, dataY);
          dataX = changeData.dataX;
          dataY = changeData.dataY;
        }
        this.setHighLightPoint(dataX, dataY, mpoint);
      }
      if (dataX.length == 0) {
        this.clearall();
      }
      this.isReal = type;
      let myseries = [];
      this.legendData = []
      let markLineData = [];
      if (dataX.length > 1 || type == "history") {
        markLineData = [];
      } else {
        markLineData = [
          {
            id: 'real',
            color: this.$store.state.colorMap[i],
            xAxis: dataX[0],
          },
        ];
      }
      let myYmin = "", myYmax = "";
      for (var i = 0; i < dataY.length; ++i) {
        myseries.push({
          id: dataY[i].name,
          name: dataY[i].lableName ? this.translateText('textMap.',dataY[i].lableName): this.translateText('textMap.',dataY[i].name),
          data: dataY[i].data,
          type: "line",
          showSymbol: false,
          lineStyle: {
            color: this.$store.state.colorMap[i],
            width: 1,
          },
          markLine: {
            symbol: ['none', 'none'],
            animation: false,
            data: markLineData,
          },
          connectNulls: true,
          markPoint: {
            name: "显示报警",
            symbolSize: 10,
            symbol: 'circle',
            data: this.AlarmValueData[i],
            // symbol:
            //   "path://M512 456.310154L94.247385 38.557538a39.542154 39.542154 0 0 0-55.689847 0 39.266462 39.266462 0 0 0 0 55.689847L456.310154 512 38.557538 929.752615a39.542154 39.542154 0 0 0 0 55.689847 39.266462 39.266462 0 0 0 55.689847 0L512 567.689846l417.752615 417.752616c15.163077 15.163077 40.290462 15.36 55.689847 0a39.266462 39.266462 0 0 0 0-55.689847L567.689846 512 985.442462 94.247385a39.542154 39.542154 0 0 0 0-55.689847 39.266462 39.266462 0 0 0-55.689847 0L512 456.310154z",
            // // data:this.AlarmValueData,
            // //  color: '#FF0B00'
            // data: this.AlarmValueData,
            // label: {
            //   color: this.$store.state.markcolor,
            //   textBorderColor: this.$store.state.markbordercolor,
            //   textBorderWidth: 2,
            // },
            // itemStyle: {
            //   color: "#FF0B00",
            // },
          },
        });
        console.log(this.AlarmValueData)
        this.legendData.push(myseries[i].name);
        this.arry.push(dataY[i].data);
        let model = this.modelFlag && type != 'real' && routeFlag;
        for (let item in dataY[i].data) {
          if (myYmin === "") myYmin = model ? dataY[i].data[item][1] : dataY[i].data[item];
          else myYmin = Math.min(myYmin, model ? dataY[i].data[item][1] : dataY[i].data[item]);
          if (myYmax === "") myYmax = model ? dataY[i].data[item][1] : dataY[i].data[item];
          else myYmax = Math.max(myYmax, model ? dataY[i].data[item][1] : dataY[i].data[item]);
        }
      }
      that.ymin = myYmin;
      that.ymax = myYmax;
      if(this.alarmFlag && this.aline.length){
        let tempAlineY = this.aline.map(item => {
          return item.yAxis
        }).sort((a, b) => {
          return b - a
        })
        myYmax = Math.max(myYmax,tempAlineY[0])
        myYmin = Math.min(myYmin,tempAlineY[tempAlineY.length - 1])
      }
      var mydatazoom = [];
      if (type != "real") {
        mydatazoom.push({
          type: "inside",
          moveOnMouseMove: false
        });
      }

      // 实时图谱放大
      var mytoolbox = {};
      var historytoolbox = {
        show: true,
        itemGap: 8,
        itemSize: 18,
        top: 8,
        right: 5,
        iconStyle: {
          normal: {
            borderColor: this.$store.state.toolboxcolor,
          },
          emphasis: {
            textPadding: this.$store.state.paddingtop,
            textFill: this.$store.state.toolboxtextcolor,
          },
        },
        feature: {
          //主副游标
          ...this.getPrimarySecondary(),
          ...this.getMarkPoint(),
          ...this.custombrush(),
          ...this.getMyBrushRestore(),
          ...this.getMyUseNowTime(),
          ...this.getAlarmLine(),
          ...this.getMark(),
          ...this.getModel(),
          ...this.getMarkWavePoint(),
          // ...this.reDataZoomIn(),
          // ...this.reDataZoomOut(),
          myover: {
            show: false,
            title: this.translateText("textMap.","历史概貌图"),

            //readOnly:true,
            // iconStyle:{
            //   normal:{
            //     borderColor: '#ffffff',
            //   },
            //   emphasis:{
            //     borderColor:'#00A4E9',
            //   }
            // },
            icon: 'M13.5,7.1c0,3.7-2.9,6.5-6.5,6.5s-6.5-2.9-6.5-6.5c0-3.7,2.9-6.5,6.5-6.5S13.5,3.4,13.5,7.1z M10,5.8V4.3H3.1\n' +
              '\tV10h3.5 M4.8,5.4C4.5,5.4,4.2,5.6,4.2,6c0,0.3,0.2,0.6,0.6,0.6c0.3,0,0.6-0.2,0.6-0.6S5.1,5.4,4.8,5.4z M6.4,7.8L6,7.3\n' +
              '\tc-0.1-0.1-0.2-0.1-0.3,0L3.3,9.2 M7.3,9.2c0.2,0.7,0.9,1.3,1.8,1.3c1,0,1.8-0.8,1.8-1.8c0-0.9-0.8-1.8-1.8-1.8\n' +
              '\tc-0.5,0-0.9,0.2-1.3,0.5 M7.3,6.7L7.1,7.9l1,0.1 M9.1,7.6V9h0.8',
            // icon: 'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M10.2,5.8V4.3H3.6v5.5\n' +
            //   '\th2.8 M5.2,5.5c-0.3,0-0.6,0.2-0.6,0.6c0,0.3,0.2,0.6,0.6,0.6c0.3,0,0.6-0.2,0.6-0.6S5.5,5.5,5.2,5.5z M6.7,7.7L6.3,7.2\n' +
            //   '\tC6.2,7.1,6.1,7.1,6,7.2L3.8,9 M7.3,9c0.2,0.7,0.9,1.2,1.7,1.2c1,0,1.7-0.8,1.7-1.7S9.9,6.8,9,6.8C8.5,6.8,8.1,7,7.8,7.3 M7.4,6.6\n' +
            //   '\tL7.3,7.7l1-0.1 M9,7.5v1.3h0.8',
            //icon: "M61.88,89.45H4.71V8M4.82,65S16.08,45.84,25.29,45.73c13.1-.15,18.63,17.4,31.65,17.4,15.07,0,17-21.82,19-30s3.79-18.56,15.12-17M81.54,62.66A15.91,15.91,0,1,0,97.45,78.57,15.91,15.91,0,0,0,81.54,62.66Zm.26,8V78a.42.42,0,0,0,.42.42h7",

            onclick: function () {
              that.iscan = !that.iscan;
              //alert(this.iscan)
              if (that.iscan == true) {
                var option = {
                  toolbox: {
                    feature: {
                      myover: {
                        iconStyle: {
                          borderColor: "#74ACC8",
                        },
                      },
                    },
                  },
                };
                that.mychart.setOption(option);
              } else {
                var option = {
                  toolbox: {
                    feature: {
                      myover: {
                        iconStyle: {
                          borderColor: that.$store.state.toolboxcolor, // 图标的线条颜色
                        },
                      },
                    },
                  },
                };
                that.mychart.setOption(option);
              }

              that.$emit("iscan", that.iscan);
            },
          },
          mySaveChart: {
            show: this.shouldShowSaveChartButton ? this.shouldShowSaveChartButton() : this.$route.path.indexOf("RotatingVibrationMonitor") != -1,
            title: this.translateText("textMap.",'设为基准数据'),
            icon: "M13.5,7c0,3.6-2.8,6.5-6.5,6.5c-3.6,0-6.5-2.8-6.5-6.5S3.4,0.5,7,0.5S13.5,3.5,13.5,7z M10.2,6.1V3.9c0-0.3-0.3-0.6-0.6-0.6h-5C4.3,3.3,4,3.6,4,3.9V10c0,0.3,0.3,0.6,0.6,0.6h1.8 M5.1,4.9h3.4 M5.1,6.6h3.4 M5.1,8.3h2.2 M11.2,6.4L7,11",
            onclick: () => {
              this.saveChartParameter()
              this.refreshSampleList()
            },
          },
          myCancel: {
            //全屏
            show: true,
            title: this.myicon ? this.translateText("textMap.",'退出全屏') : this.translateText("textMap.",'全屏'),
            icon: this.icon,
            onclick: ()=> {
              //console.log("this.FullScreenName",this.FullScreenName),
              that.$emit("cancelFull");
              that.$nextTick(() => {
                console.log(this.FullScreenName);
                that.updateMarkPoint(this.FullScreenName == this.translateText("textMap.",'全屏')   ? true : false);
              })
            },
          },
          saveAsImage: {
            title: this.translateText("textMap.",'导出'),
            icon: 'M13.5,7.1c0,3.7-2.9,6.5-6.5,6.5s-6.5-2.9-6.5-6.5c0-3.7,2.9-6.5,6.5-6.5S13.5,3.4,13.5,7.1z M6.3,6.1H4.7\n' +
              '\tL7,8.7l2.3-2.5H7.8l-0.1-3H6.2L6.3,6.1z M3.3,8.6c0,0,0.2,1.9,2.2,1.9c1.4,0,1.7,0,3,0c2,0,2.1-1.9,2.1-1.9',
            // icon: 'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M6.3,6.1H4.7L7,8.7\n' +
            //   '\tl2.3-2.5H7.8V3.5H6.3L6.3,6.1z M3.3,8.6c0,0,0.2,1.9,2.2,1.9c1.4,0,1.7,0,3,0c2,0,2.1-1.9,2.1-1.9',
            //icon: "M279,16.6V444.4M94.6,251.9,265.8,438.8a17.76,17.76,0,0,0,25.2,1.1,11.41,11.41,0,0,0,1.1-1.1L463.3,251.9M6.5,397.1V537.6a23.69,23.69,0,0,0,23.7,23.7H527.7a23.69,23.69,0,0,0,23.7-23.7h0V397.1",
            iconStyle: {
              emphasis: {
                textPadding: [
                  this.$store.state.paddingtop,
                  this.$store.state.paddingright,
                ],
              },
            },
          },
          myExportTrendToExcel: {
            show: this.$route.path.indexOf("RotatingVibrationMonitor") != -1 || this.$route.path === '/TrendAnalysis', //在旋转振动监测和机泵趋势分析显示
            title: this.translateText("textMap.","数据导出"),
            icon: "M13.5,7.1c0,3.7-2.9,6.5-6.5,6.5s-6.5-2.9-6.5-6.5c0-3.7,2.9-6.5,6.5-6.5S13.5,3.4,13.5,7.1z M7.1,7l0,3.9M5.4,9.9l1.5,1.4c0.2,0.1,0.4,0.1,0.6,0l1.4-1.6 M8.7,8.4h1.2c0,0,1.2-0.3,1.2-1.4c0-1.2-1.7-1.6-1.7-1.6s-0.5-2-2.3-2s-2.6,2-2.6,2c-0.9,0-1.6,0.7-1.6,1.5v0c0,0.8,0.7,1.5,1.6,1.5h0.9",
            onclick: () => {
              this.exportTrendToExcel(this.response, this.pointType)
            },
          },
        },
      };
      //将细化更名为放大，关闭原关闭放大功能
      this.zoomState = false;
      if (this.$route.path.indexOf("Overview") != -1) {
        historytoolbox.feature.myover.show = true;
      }

      var realtoolbox = {
        show: true,
        itemGap: 8,
        itemSize: 18,
        top: 8,
        right: 5,
        iconStyle: {
          normal: {
            borderColor: this.$store.state.toolboxcolor,
          },
          emphasis: {
            textPadding: this.$store.state.paddingtop,
            textFill: this.$store.state.toolboxtextcolor,
          },
        },
        feature: {
          //主副游标
          ...this.getMarkPoint(),
          ...this.getAlarmLine(),
          brush: {
            show: false,
            type: ["lineX"],
            title: {
              lineX: this.translateText("textMap.",'细化'),
            },
          },
          myCancel: {
            show: true,
            title: this.myicon ? this.translateText("textMap.",'退出全屏') : this.translateText("textMap.",'全屏'),
            icon: this.icon,

            onclick: function () {
              // console.log("this.FullScreenName",this.FullScreenName),
              that.$emit("cancelFull");
            },
          },
          saveAsImage: {
            title: this.translateText("textMap.",'导出'),
            icon: 'M13.5,7.1c0,3.7-2.9,6.5-6.5,6.5s-6.5-2.9-6.5-6.5c0-3.7,2.9-6.5,6.5-6.5S13.5,3.4,13.5,7.1z M6.3,6.1H4.7\n' +
              '\tL7,8.7l2.3-2.5H7.8l-0.1-3H6.2L6.3,6.1z M3.3,8.6c0,0,0.2,1.9,2.2,1.9c1.4,0,1.7,0,3,0c2,0,2.1-1.9,2.1-1.9',
            // icon: 'M13.4,7c0,3.6-2.9,6.4-6.4,6.4S0.6,10.5,0.6,7c0-3.6,2.9-6.4,6.4-6.4S13.4,3.4,13.4,7z M6.3,6.1H4.7L7,8.7\n' +
            //   '\tl2.3-2.5H7.8V3.5H6.3L6.3,6.1z M3.3,8.6c0,0,0.2,1.9,2.2,1.9c1.4,0,1.7,0,3,0c2,0,2.1-1.9,2.1-1.9',
            iconStyle: {
              emphasis: {
                textPadding: [
                  this.$store.state.paddingtop,
                  this.$store.state.paddingright,
                ],
              },
            },
          },
        },
      };
      if (type != "real") {
        mytoolbox = historytoolbox;
      } else {
        // console.log("实时",this.FullScreenName)
        mytoolbox = realtoolbox;
      }

      if (
        this.$route.path == "/UnitOverviewMap" ||
        this.$route.path == "/RotatingMachineryGraph/RotatingOverviewGrap" ||
        this.$route.path == "/ReciprocatMachineryGraph/OverviewGraph1" ||
        this.$route.path == "/DieselMonitorSystem/OverviewGraph" ||
        this.$route.path == "/gasTurbineGraph/GasOverviewGrap" ||
        this.$route.path == "/HeatingFurnaceGraph/HeatingFurnaceUnitOverviewMap" ||
        this.$route.path == "/WirelessPumpGraph/WirelessPumpUnitOverviewMap" ||
        this.$route.path == "/Offline/OLUnitOverviewMap"
      ) {
        mytoolbox.feature.myCancel.show = false;
      } else {
        mytoolbox.feature.myCancel.show = true;
      }
      if (this.$route.path.indexOf("StartStopGraph") != -1) {
        try {
          mytoolbox.feature.myCancel.show = false;
          mytoolbox.feature.brush.show = false;
          mytoolbox.feature.myrestore.show = false;
        } catch (e) {
          console.log(e);
        }

      }

      that.arrx = dataX;
      let left , right
      if(this.$store.state.nowTrendStartTime && this.$store.state.nowTrendEndTime){
        left = this.$store.state.nowTrendStartTime
        right = this.$store.state.nowTrendEndTime
      }else{
        left = dataX[0]
        right = dataX[dataX.length - 1]
      }
      var option = {
        backgroundColor: this.$store.state.leftconbgcolor,
        grid: [
          {
            left: this.$store.state.grid.left,
            right: this.$store.state.grid.right,
            top: this.$store.state.grid.top,
            bottom: this.$store.state.grid.trendBottom,
          },
        ],
        title: [{
          id: 'title',
          top: "12px",
          left: "center",
          text: title,
          textStyle: {
            fontSize: 16, //大小
            color: this.$store.state.textcolor,//颜色
            fontFamily: "Microsoft YaHei UI"

          },
        },{
          id: 'offset',
          top: "13px",
          left: this.$store.state.grid.left,
          textStyle:{
            fontSize: 10,
          }
        },{
          id: 'Main-Cursor',
          left: this.$store.state.grid.left,
          top: "32px",
          textStyle:{
            fontSize: 10,
             color: this.$store.state.primarySecondaryColor[0],
          }
        },{
          id: 'Auxiliary-Cursor',
          left: this.mychart.getWidth() * parseFloat(this.$store.state.grid.left) / 100 + 300,
          top: "32px",
          textStyle:{
            fontSize: 10,
            color: this.$store.state.primarySecondaryColor[1],
          }
        },
          {
            id: 'offsets',
            top: "13px",
            left: this.$store.state.grid.left,
            textStyle:{
              fontSize: 10,
            }
          }],
        tooltip: {
          trigger: "axis",
          confine: true,
          formatter:(params)=>{
            let list = []
            let listItem = ''
            let myparams = []
            this.tooltipIndex = params[0].dataIndex
            if(params.length == 1) {
              this.tooltipSeriesIndex = params[0].seriesIndex
            }
            else {
              this.tooltipSeriesIndex = ''
            }
            params.forEach((pitem,paramunit)=>{
              if(pitem.data[1]!==null)
              {
                myparams.push(pitem);
              }

            })
            if (this.modelFlag && type != 'real' && routeFlag) {
              // console.log(params[0].axisValue);
              this.$store.state.tooltipTime = params[0].axisValue;
            }
            // for (let i = 0; i < params.length; i++) {
            //     list.push(
            //       this.modelFlag && type != 'real' && routeFlag?
            //       '<i style="display: inline-block;width: 10px;height: 10px;background: ' +
            //       params[i].color + ';margin-right: 5px;border-radius: 50%;}"></i><span style="  display:inline-block;">' +
            //       params[i].seriesName + ': ' +
            //       '</span> ' + params[i].value[1] :
            //       '<i style="display: inline-block;width: 10px;height: 10px;background: ' +
            //       params[i].color + ';margin-right: 5px;border-radius: 50%;}"></i><span style="  display:inline-block;">' +
            //       params[i].seriesName + ': ' +
            //       '</span> ' + params[i].value
            //     )
            //
            // }
            for (let i = 0; i < myparams.length; i++) {
              list.push(
                this.modelFlag && type != 'real' && routeFlag?
                  '<i style="display: inline-block;width: 10px;height: 10px;background: ' +
                  myparams[i].color + ';margin-right: 5px;border-radius: 50%;}"></i><span style="  display:inline-block;">' +
                  myparams[i].seriesName + ': ' +
                  '</span> ' + this.roundToDecimalPlaces(parseFloat(myparams[i].value[1]),3) + " " + flagY.replace(/^\[|\]$/g, '') :
                  '<i style="display: inline-block;width: 10px;height: 10px;background: ' +
                  myparams[i].color + ';margin-right: 5px;border-radius: 50%;}"></i><span style="  display:inline-block;">' +
                  myparams[i].seriesName + ': ' +
                  '</span> ' + this.roundToDecimalPlaces(parseFloat(myparams[i].value),3) + " " + flagY.replace(/^\[|\]$/g, '')
              )

            }
            list.unshift(this.modelFlag && type != 'real' && routeFlag?
              this.timeToStamp(myparams[0].axisValue):
              myparams[0].axisValue);
            listItem = list.join('<br>')
            return '<div class="showBox">' + listItem + '</div>'
          }
        },
        dataZoom:[{
          type: "inside",         //详细配置可见echarts官网
          zoomLock: true,
          disabled: true, // 禁用内部的缩放功能
        }],
        toolbox: mytoolbox,
        // graphic: createGraphicFromToolbox(historytoolbox),
        color: this.$store.state.colorMap,
        brush: {
          xAxisIndex: "all",
          transformable: false,
          outOfBrush: {
            colorAlpha: 0.1,
          },
          throttleType: "debounce",
          throttleDelay: 2000,
        },
        legend: {
          type: 'scroll',
          pageIconColor: this.$store.state.selectbordercolor,
          pageIconInactiveColor: this.$store.state.selectbordercolor,
          pageTextStyle:{
            color: this.$store.state.selectbordercolor
          },
          left: 50,
          bottom: 6,
          data: this.legendData.map((name) => {
            return {
              name: this.translateText('textMap.',name),
              icon: 'rect',  // 使用矩形图标
            };
          }),
          itemWidth: 12,
          itemHeight: 6,
          itemGap: 24,  // 图例项之间的间距
          formatter: function (name) {
            return '{a|' + name + '}';
          },
          textStyle: {
            rich: {
              a: {
                verticalAlign: 'middle',  // 使图标垂直居中
                lineHeight: 12,  // 根据图标高度调整行高
                fontSize: 12,
                color: this.$store.state.selectbordercolor,
                padding: [0, 0, 3, 4],  // 调整文字和图标的间距
              }
            }
          }
        },
        // xAxis
        xAxis: {
          axisLine: {
            onZero: false,
          },
          // name: flagX,
          name: flagX == '[时间]' ? this.translateText("textMap.",'趋势图时间单位') : flagX,
          data: dataX,
          nameLocation: 'end',//将名称设置为起始位置
          nameTextStyle: {
            padding:[0,0,0,-14]
          },
          // axisLabel: {
          //   overflow: 'truncate', // 文本超出宽后进行换行
          //   width: '1px',
          //   textBorderColor: 'red'
          // },
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            // color: this.$store.state.textcolor,
            color: this.$store.state.selectbordercolor,
            // overflow: 'breakAll', // 文本超出宽后进行换行
            // width: '10px',
            // textBorderColor: 'red',
            formatter: (value, index) => {
              // console.log(value);
              return  this.modelFlag && type != 'real' && routeFlag ? this.timeToStamp(value) : value.replace(' ', '\n');
            },
            showMinLabel: true,
            showMaxLabel: true,
            padding: [0, 5, 0, 5]
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", //'dotted'虚线 'solid'实线，
              color: this.$store.state.linecolor,
            },
          },
          type: this.modelFlag && type != 'real' && routeFlag ? "time" : "category",
          min: this.modelFlag && type != 'real' && routeFlag ? left : null,
          max: this.modelFlag && type != 'real' && routeFlag ? right : null,
          boundaryGap: false,
        },
        yAxis: {
          name: flagY,
          nameLocation: 'end',//将名称设置为起始位置
          nameTextStyle: {
            padding:[0,45,-6,0]
          },
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            fontSize: 10,
            // color: this.$store.state.textcolor,
            showMinLabel: true,
            showMaxLabel: true,
            color: this.$store.state.selectbordercolor,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted", //'dotted'虚线 'solid'实线，
              color: this.$store.state.linecolor,
            },
          },
          min: this.roundDown(myYmin, myYmax),
          max: this.roundUp(myYmin, myYmax),
          type: "value",
          splitNumber: 3,
        },
        series: myseries,
      };
      this.allseries = myseries;
      that.nowOption = option;
      that.mychart.setOption(option);

      if (this.brushState) {
        that.mychart.dispatchAction({
          type: "takeGlobalCursor",
          key: "brush",
          brushOption: {
            brushType: "lineX",
          },
        });
      }
      if(this.alarmFlag){
        that.handleAlarm(this.alarmFlag)
      }
      this.mychart.off("brushEnd")
      this.mychart.on("brushEnd", (params) => {
        this.renderBrushed(params);
      })
      this.mychart.getZr().off("click");
      this.mychart.getZr().on("click", this.chartClick);
      this.mychart.off('dataZoom')
      this.mychart.on('dataZoom', (e) => {
        this.updateMarkPoint()
      });
      if(this.nowFeature == 'one' || this.nowFeature == 'two' || this.nowFeature == 'three' || this.nowFeature == 'half' || this.nowFeature == 'phaseOne' || this.nowFeature == 'phaseTwo' || this.nowFeature == 'phaseThree' || this.nowFeature == 'phaseHalf') {
        this.mychart.getZr().on('contextmenu', this.contextMenu)
      }else{
        this.mychart.getZr().off('contextmenu', this.contextMenu)
      }
      this.mychart.getZr().on('mousemove', this.mouseMoveEvent)// 监听鼠标移动事件
      this.mychart.getZr().on('globalout', this.globalOutEvent);
      this.updateAlarmPoint()
    },
    setchart(flagX, flagY, dataX, dataY, title, myType, initialData, mpoint = []) {
      if(dataX.length == 0) return
      if(initialData){
        this.chartData = initialData.chartData;
        this.nowFeature = initialData.feature;
        this.requistData = initialData.requistData;
        this.originalDataMap = null;
      }
      if(flagY === '[m/s2]') {
        flagY = '[m/s²]';
      }
      if(flagY === '[]') {//当y轴没有单位时，去掉[]
        flagY = '';
      }
      this.drawchart();
      this.offset = ''
      this.mainCursor = ''
      this.auxiliaryCursor =  ''
      this.status = myType;
      // let type = this.status = title.indexOf('实时') != -1 || title.indexOf('real')!= -1 ? 'real' : 'history'
      this.Title = title.indexOf('趋势图') == -1 && title.indexOf('trend') == -1 && title.indexOf('Trend') == -1 ? title + ' 趋势图' : title
      title = ''
      this.Title.trim().split(' ').forEach(item => title += this.translateText('textMap.', item)+' ')
      // if (myType) {
      //   type = this.status = myType;
      // }
      this.$nextTick(() => {
        console.log('>>>>>>>>>>', flagY, dataY);
        this.setchartdata(flagX, flagY, dataX, dataY, title, myType, mpoint);
        this.setChartAfter();
        this.createDropdownMenu();

      });
    },
    updateAlarmPoint(){
      if(this.$store.state.pointId && this.$store.state.alarmEndTime){
        let xTime = new Date(this.$store.state.alarmEndTime).getTime()
        this.$store.state.alarmEndTime = ''
        let option = this.mychart.getOption()
        let xAxisData = option.xAxis[0].data
        // 将获取的时间，遍历成时间戳
        let xAxisDataTime = xAxisData.map(x => new Date(x).getTime())
        // 找到最接近的时间值
        xTime = this.findClosestValue(xTime, xAxisDataTime);
        let xIndex = xAxisDataTime.indexOf(xTime);
        let param = {};
        param.name = option.xAxis[0].data[xIndex];
        param.xIndex = xIndex
        param.seriesNameIndex = 0
        param.seriesName = option.series[0].name;
        param.seriesId = option.series[0].id;//seriesId的值用于往复-振动监测，点击趋势图后显示波形图，请求传参数
        param.seriesY = option.series[0].data[xIndex]
        param.isPrimaryCursor = this.PrimarySecondary.isMark !== undefined ? this.PrimarySecondary.isMark : true;
        if(this.status == undefined || this.status != 'real') {
          this.drawLineAndProLine(param.name, 0, param, null)
          // 告诉父组件刷新其它页面，父组件如果不执行这个函数，相当于没有影响
          this.$emit("chartinfo", param);
        }
      }
    },
    changechart(x, y) {
      console.log(x, y);
      if(typeof x != 'number' && typeof x != 'string'){
        x = x[0]
        y = y.map(item => {
          return item.data[0]
        })
      }
      //x 横轴新添数据
      // y 一个[] 纵轴每项新增的数据
      if(this.mychart.getOption().series.length == 0){ //图谱被清空，实时请求的数据过来，抛个异常不再往下执行
        throw new Error('实时请求');
      }
      let that = this;
      if (that.arrx[that.arrx.length - 1] === x) {
        return;
      }

      if (that.arrx.length >= 50) {
        that.arrx.shift();
        for (var i = 0; i < that.arry.length; ++i) {
          that.arry[i].shift();
        }
      }
      var newseries = [];
      that.arrx.push(x);

      for (var i = 0; i < that.arry.length; ++i) {
        that.arry[i].push(y[i]);
        newseries.push({
          type: "line",
          data: that.arry[i],
          lineStyle: {
            width: 1,
          },
          markLine: {
            data: [],
          },
        });

        that.ymin = Math.min(that.ymin, y[i]);

        that.ymax = Math.max(that.ymax, y[i]);
      }
      let mychart = this.mychart.getOption();
      let markLineData = mychart.series[0].markLine.data;
      markLineData = markLineData.filter(i => {
        return i.id != "real";
      })
      newseries[0].markLine.data = markLineData

      //向上取整
      function myUpRound(x) {
        let flag = 1;
        if (x < 0) flag = 0;
        let newx =  Math.ceil(Math.abs(x));
        let length = newx.toString().length;
        let myNewx = 0;
        if (length == 1) {
          myNewx = newx ;
        } else if (length == 2) {
          let max = newx / 10;
          myNewx = Math.ceil(max) * 10;
        } else {
          let pow = Math.pow(10, length - 2);
          let max = newx / pow;
          myNewx = Math.ceil(max) * pow;
        }
        if (flag) return myNewx;
        else return -myNewx;
      }
      // 向下取整
      function myDownRound(x) {
        let flag = 1;
        if (x < 0) flag = 0;
        let newx =  Math.floor(Math.abs(x));;
        let length = newx.toString().length;
        let myNewx = 0;
        if (length == 1) {
          myNewx = newx ;
        } else if (length == 2) {
          let max = newx / 10;
          myNewx = Math.floor(max) * 10;
        } else {
          let pow = Math.pow(10, length - 2);
          let max = newx / pow;
          myNewx = Math.floor(max) * pow;
        }
        if (flag) return myNewx;
        else return -myNewx;
      }

      let myMax =that.ymax, myMin =that.ymin
      if(this.alarmFlag && this.aline.length){
        let tempAlineY = this.aline.map(item => {
          return item.yAxis
        }).sort((a, b) => {
          return b - a
        })
        myMax = Math.max(that.ymax,tempAlineY[0])
        myMin = Math.min(that.ymin,tempAlineY[tempAlineY.length - 1])
      }
      myMax = this.roundUp(myMin, myMax)
      myMin = this.roundDown(myMin, myMax)
      var option = {
        xAxis: {
          axisLine: {
            onZero: false,
          },
          data: this.arrx,
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            color: this.$store.state.selectbordercolor,
            overflow: 'break', // 文本超出宽后进行换行
            width: 70,
          },
        },
        yAxis: {
          axisTick: {
            lineStyle: {
              color: this.$store.state.tickcolor,
            },
          },
          axisLabel: {
            color: this.$store.state.selectbordercolor,
          },
          min: myMax,
          max: myMin,
        },
        series: newseries,
      };
      this.$nextTick(() => {
        this.mychart.setOption(option);
      })
    },
    renderBrushed(params) {
      this.delALLMarkPoint()
      let left, right;
      if (!this.modelFlag && this.$route.path.indexOf('StartStopGraph') == -1) {
        if (params.batch[0].areas.length == 0) {
          //没有选框
          return;
        }
        left = params.batch[0].areas[0]["coordRange"][0];
        right = params.batch[0].areas[0]["coordRange"][1];
        if (left < 0) {
          left = 0;
        }
        if (right >= this.arrx.length) {
          right = this.arrx.length - 1;
        }
        let tmpLeft = left;
        let tmpRight = right;
        left = this.arrx[left];
        if (!parseInt(left)) {
          let flag = true;
          for (let item = tmpLeft - 1; item >= 0; item--) {
            if (parseInt(this.arrx[item])) {
              left = this.arrx[item];
              tmpLeft = item;
              flag = false;
              break;
            }
          }
          if (flag) {
            for (let item = tmpLeft + 1; item < this.arrx.length; item++) {
              if (parseInt(this.arrx[item])) {
                left = this.arrx[item];
                tmpLeft = item;
                flag = false;
                break;
              }
            }
          }
        }
        right = this.arrx[right];
        if (!parseInt(right)) {
          let flag = true;
          for (let item = tmpRight + 1; item < this.arrx.length; item++) {
            if (parseInt(this.arrx[item])) {
              right = this.arrx[item];
              tmpRight = item;
              flag = false;
              break;
            }
          }
          if (flag) {
            for (let item = tmpRight - 1; item >= 0; item--) {
              if (parseInt(this.arrx[item])) {
                right = this.arrx[item];
                tmpRight = item;
                flag = false;
                break;
              }
            }
          }
        }
        if (tmpLeft > tmpRight) {
          left = this.arrx[tmpRight];
          right = this.arrx[tmpLeft];
        }
      } else {
        left = params.areas[0]["coordRange"][0];
        right = params.areas[0]["coordRange"][1];
      }
      console.log(left, right)
      let series =  this.mychart.getOption().series
      let hasData = false;
      for(let i in series){
        let Data = series[i].data;
        for(let j in Data){
          let t = timeStringToTimestamp(Data[j][0]);
          if (t<=right && t>=left){
            hasData = true;
            break;
          }
        }
      }
      if(!hasData){
        this.$parent.$emit("brushdatanull")
        return;
      }
      this.refineFlag = true
      this.$store.state.nowTrendStartTime = new Date(left).valueOf()
      this.$store.state.nowTrendEndTime = new Date(right).valueOf()
      if(this.zoomState == true){
        // this.$store.state.useDataZoom = true
        this.$emit("dataZoom",new Date(left).valueOf(), new Date(right).valueOf());
      }else if (this.brushState){
        this.$emit("refine", new Date(left).valueOf(), new Date(right).valueOf());
      }
      this.mychart.dispatchAction({
        type: 'brush',
        areas: [] // 清除所有刷选区域
      })
    },
    timeToStamp(timestamp) {
      var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + '\n';
      var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
      var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
      var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds()) ;
      var ms =  '.' + (timestamp % 1000).toString();
      while(ms.length < 3) {
        ms = '0' + ms;
      }
      //var nowtime = new Date(Y+M+D+h+m+s);
      // console.log(timestamp, Y+M+D+h+m+s+ms);
      return Y+M+D+h+m+s;
    },
    saveChartParameter(){
      this.$store.state.showEventDialogFlag = true
      this.$store.state.postData = {
        equipmentUuid: this.requestData.equipmentUuid,
        // pointUuid: this.requestData.pointUuid,
        markTime: this.requestData.trendTime,
        feature: -1,
        amplitude: -1,
        phase: -1,
        name: "测试波形对比事件",
        isDefault: -1,
        datatype: -1,
        childType: -1,
        eventType: 2,
        offsetsRange: this.requestData.offsetsRange,
        info:{...this.requestData}
      }
    },
    // 手动触发样本列表刷新
    refreshSampleList() {
      this.$store.commit('toggleSampleRefreshFlag');
    },

  },
};
</script>

<style scoped>
  #myTrendChart{
    --bgcolor: #fdfdfd;
    --tablecolor: #ffffff;
    --textcolor: #000000;
    --buttoncolor: #1677FF;
    --buttontextcolor: #ffffff;
    --conbgcolor: #0D0F1F;
    --defaultButtonColor: #1D8EFF;
    .selectListMenu{
      width: 240px;
      border: 1px solid rgb(102, 104, 108);
      border-radius: 5px;
      z-index: 99999999;
      background-color: var(--bgcolor);
      color: var(--textcolor);

      .selectListMenuHeader{
        font-weight: bold;
        padding: 14px 20px 14px 20px;
        border-bottom: 0.5px solid #c0c4cc;
        font-size: 16px;
        line-height: 20px;
        .deleteMenuWrapper{
          height: 20px !important;
          width: 20px !important;
          fill: #ccc;
          cursor: pointer;
          position: absolute;
          top: 14px;
          right: 20px;
          width: 14px;
          height: 20px;
        }
        .deleteMenuWrapper:hover{
          background-color: #ff0000;
        }
      }

      .selectListMenuBody{
        .option{
          padding: 10px 20px 10px 20px;
        }
        .option:hover{
          background-color: var(--buttoncolor);
          color: var(--bgcolor);
        }
      }

      .selectListMenuBottom{
        border-top: 1px solid #c0c4cc;
        .option{
          padding: 10px 20px 10px 20px;
        }
        .option:hover{
          background-color: var(--buttoncolor);
          color: var(--bgcolor);
        }
      }
    }
    .createDataSetMenu{
      //width: 1024px;
      border: 1px solid rgb(102, 104, 108);
      border-radius: 5px;
      z-index: 99999999;
      font-size: 16px;
      line-height: 100%;
      background-color: var(--bgcolor);
      color: var(--textcolor);

      .createDataSetMenuHeader{
        padding: 20px 10px 14px 20px;
        align-items: center;
        font-weight: bold;
        .deleteMenuWrapper{
          height: 20px !important;
          width: 20px !important;
          fill: #ccc;
          cursor: pointer;
          position: absolute;
          top: 14px;
          right: 20px;
          width: 14px;
          height: 20px;
        }
        .deleteMenuWrapper:hover{
          background-color: #ff0000;
        }
      }

      .createDataSetMenuBody{
        padding-top: 20px;
        padding-bottom: 20px;
        border-top: 1px solid rgb(102, 104, 108);
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        align-items: center;
        .formItem{
          font-weight: bold;
          display: flex;
          padding: 20px 0px 0px 0px;
          margin-left: 20px;
          align-items: center;
          .title{
            //min-width: 80px;      /* 最小宽度，保证短文字不会太窄 */
            text-align: left;   /* ✅ 文字右对齐 */
            margin-right: 12px;  /* ✅ 与输入区域的间距 */
            flex-shrink: 0;
          }
          .name{
            margin-left: 20px;
            padding-left: 10px;
            height: 30px;
            width: 300px;
            border: 0.5px solid rgb(102, 104, 108);
            border-radius: 4px;
            box-sizing: border-box;
            background-color: var(--bgcolor);
            color: var(--textcolor);
          }
          .default{
            margin-left: 20px;
          }
          .type{
            margin-left: 20px;
          }
          .optionConf{
            font-weight: normal;
            font-size: medium;
          }
          .childType{
            margin-left: 20px;
          }
          .range{
            margin-left: 20px;
          }

          .default {
            width: 46px;
            height: 22px;
            vertical-align: bottom; /* ✅ 跟文字等垂直居中对齐 */
            display: inline-block;  /* ✅ 避免换行和布局错乱 */
            box-sizing: border-box;
            position: relative;
            background: #cccccc;
            //border: 1px solid #dfdfdf;
            border-radius: 16px;
            line-height: 20.5px;
            text-align: center;
            cursor: pointer;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            outline: 0;
          }

          .default:active,
          .default:visited {
            outline: none;
          }

          .default:before {
            content: attr(data-off);
            position: absolute;
            top: 0;
            left: 1px;
            padding-left: 13px;
            border-radius: 15px;
            background-color: #cccccc;
            color: #fff;
            font-size: 12px;
          }

          .default:after {
            content: " ";
            position: absolute;
            top: 4px;
            left: 2px;
            width: 12px;
            height: 12px;
            border-radius: 15px;
            background-color: #ffffff;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
            transition: transform 0.3s;
          }

          .default:checked {
            //border-color: #0c66ff;
            background-color: var(--buttoncolor);
          }

          .default:checked:after {
            transform: translateX(28px);
          }

          .default:checked:before {
            content: attr(data-on);
            padding-left: 0px;
            padding-left: 2px;
            background-color: var(--buttoncolor);
            color: #fff;
            width: 24px;
          }
        }
        #formItem4{
          //margin-left: 32px;
        }
        #formItem5{
          //margin-left: 16px;
        }
        .buttons{
          display: flex;
          justify-content: flex-end; /* 将按钮对齐到容器的右侧 */
          padding-right: 20px; /* 距离右侧20px */
          margin-top: 20px;
          #createDataSetCancel{
            height: 24px;
            border: 1px solid rgb(102, 104, 108);
            border-radius: 4px;
            margin-left: 10px; /* 与保存按钮之间的间距 */
            background-color: var(--bgcolor);
            color: var(--textcolor);
            transition: background-color 0.3s, color 0.3s; /* 平滑过渡效果 */
          }
          #createDataSetSave{
            //width: 42px;
            height: 24px;
            border: 1px solid #007bff;
            border-radius: 4px;
            background-color: var(--buttoncolor);
            color: var(--buttontextcolor);
            margin-left: 10px; /* 与取消按钮之间的间距 */
            transition: background-color 0.3s, color 0.3s; /* 平滑过渡效果 */
          }
        }
      }
    }
    .dataBaseListMenu{
      width: 1378px;
      border: 1px solid rgb(102, 104, 108);
      border-radius: 5px;
      z-index: 99999999;
      font-size: 16px;
      line-height: 100%;
      background-color: var(--bgcolor);
      color: var(--textcolor);

      .dataBaseListMenuHeader{
        padding: 14px 20px 14px 20px;
        align-items: center;
        font-weight: bold;
        .deleteMenuWrapper{
          height: 20px !important;
          width: 20px !important;
          fill: #ccc;
          cursor: pointer;
          position: absolute;
          top: 14px;
          right: 20px;
          width: 14px;
          height: 20px;
        }
        .deleteMenuWrapper:hover{
          background-color: #ff0000;
        }
      }
      .dataBaseListMenuBody{
        padding-top: 20px;
        padding-bottom: 20px;
        border-top: 1px solid rgb(102, 104, 108);
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        align-items: center;
        .dataList{
          table {
            border-collapse: collapse;
            margin-bottom: 20px;
            margin-left: 20px;
          }

          th, td {
            border: 1px solid #ddd;
            padding: 8px;
            text-align: left;
          }

          th {
            background-color: var(--conbgcolor);
            font-weight: bold;
          }

          .defaultBtn,
          .deleteBtn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            height: 32px;         /* ✅ 设置固定高度 */
            padding: 0 8px;       /* ✅ 设置一致的内边距 */
            font-size: 14px;      /* ✅ 统一字体 */
            background: transparent;
            border: none;
            cursor: pointer;
            line-height: 1;
            vertical-align: middle;
            color: var(--textcolor);
          }


          .defaultBtn:hover:not(:disabled) {
            text-decoration: underline;  /* 可选，增加悬停效果 */
            color: var(--textcolor); /* hover 状态颜色 */
          }

          .defaultBtn:disabled {
            color: var(--defaultButtonColor) !important; /* hover 状态颜色 */
          }


          .deleteBtn:hover {
            color: #c0392b; /* hover 更深色 */
          }


          th input[type="checkbox"], td input[type="checkbox"] {
            margin: 0;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }
          .pagination{
            margin: 0px 10px 10px 0px;
            button {
              margin: 0 3px;
              padding: 3px 6px;
              font-size: 14px;
              border: 1px solid rgb(102, 104, 108);
              background-color: var(--bgcolor);
              color: var(--textcolcor);
              border-radius: 6px;
              cursor: pointer;
              transition: all 0.2s ease-in-out;
              box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
            }

            button:hover {

            }

            button:disabled {
              cursor: not-allowed;
              border: 1px solid rgb(102, 104, 108);
              background-color: var(--bgcolor);
              box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
              color: var(--textcolcor);
            }

            button.active {
              background-color: #007bff;
              color: #fff;
              border-color: #007bff;
            }

          }
        }
        .buttons{
          display: flex;
          justify-content: flex-end; /* 将按钮对齐到容器的右侧 */
          padding-right: 20px; /* 距离右侧20px */
          #dataBaseListMenuCancel{
            //width: 42px;
            height: 24px;
            cursor: pointer;
            border: 1px solid rgb(102, 104, 108);
            border-radius: 4px;
            margin-left: 10px; /* 与保存按钮之间的间距 */
            background-color: var(--bgcolor);
            color: var(--textcolor);
          }
          #dataBaseListMenuSave{
            height: 24px;
            cursor: pointer;
            border: 1px solid #007bff;
            border-radius: 4px;
            background-color: var(--buttoncolor);
            color: var(--buttontextcolor);
            margin-left: 10px; /* 与取消按钮之间的间距 */
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ComUtils/TrendGraph.vue